import { CSSProperties, useEffect, useState } from 'react';

import { Header } from '@/components/Profile/Header/Header.tsx';
import UIConfig from '@/UIConfig.ts';
import TabBar from '@/components/Profile/Header/Tabbar/TabBar.tsx';
import { GetMore } from '@/components/Profile/Content/GetMore/GetMore.tsx';
import MySpace from '@/components/Profile/Content/MySpace/MySpace.tsx';
// import { useJoyrideTourStore } from '@/store/useJoyrideTourStore.ts';
// import { useCloudStorage } from '@/hooks/useStorage.ts';
// import { TOUR_KEYS } from '@/constants/local_storage_keys.ts';

const Profile = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  // const { resetTour } = useJoyrideTourStore();
  // const storage = useCloudStorage();

  const handleTabChange = (activeTabIndex: number) => {
    setActiveTabIndex(activeTabIndex);
  };

  useEffect(() => {
    const preventScroll = (e: TouchEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('.modal')) return;
      e.preventDefault();
    };

    window.addEventListener('touchmove', preventScroll, { passive: false });

    return () => {
      window.removeEventListener('touchmove', preventScroll);
    };
  }, []);

  // const handleResetTour = () => {
  //   resetTour(TOUR_KEYS.DISCOVERY, storage);
  //   alert('Tour reset! Go to Discovery to see it again.');
  // };

  return (
    <div style={containerStyle}>
      <Header />
      <TabBar
        activeTabIndex={activeTabIndex}
        handleTabChange={handleTabChange}
      />
      <div style={bottomBlockStyle}>
        {activeTabIndex === 0 && <GetMore />}
        {activeTabIndex === 1 && <MySpace />}
      </div>
      {/* TODO: Remove this button after testing */}
      {/*<button*/}
      {/*  onClick={handleResetTour}*/}
      {/*  style={{*/}
      {/*    position: 'fixed',*/}
      {/*    bottom: 100,*/}
      {/*    right: 20,*/}
      {/*    padding: '10px 15px',*/}
      {/*    background: '#FDC23B',*/}
      {/*    border: 'none',*/}
      {/*    borderRadius: 8,*/}
      {/*    fontSize: 12,*/}
      {/*    fontWeight: 'bold',*/}
      {/*    zIndex: 9999*/}
      {/*  }}*/}
      {/*>*/}
      {/*  Reset Tour*/}
      {/*</button>*/}
    </div>
  );
};

const containerStyle: CSSProperties = {
  margin: 0,
  padding: 0,
  backgroundColor: UIConfig.Colors.BackgroundWhite,
  width: '100vw',
  height: 'calc(100vh - 180px)',
  marginTop: '100px',
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  position: 'absolute',
  top: 0,
  left: 0
};

const bottomBlockStyle: CSSProperties = {
  position: 'relative',
  width: '100%',
  background: UIConfig.Colors.BackgroundWhite,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '10px',
  minHeight: '58vh',
  flex: 1
};

export default Profile;
